import { render, staticRenderFns } from "./PDFPaginator.vue?vue&type=template&id=119b2dfc"
import script from "./PDFPaginator.vue?vue&type=script&lang=js"
export * from "./PDFPaginator.vue?vue&type=script&lang=js"
import style0 from "./PDFPaginator.vue?vue&type=style&index=0&id=119b2dfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports